import { configureStore } from "@reduxjs/toolkit";
import web3Store from "./web3Store";

export const store = configureStore({
    reducer: {
        web3Store:web3Store,
    },
})